import React, { Component } from 'react';
import _ from 'lodash';
import { isEmpty } from 'lodash';
import axios from 'axios';
import CommercialStockInfo from './PopUp/CommercialStockInfo';
import CommercialDashboard from './PopUp/CommercialDashboard';
import CommercialHistory from './PopUp/CommercialHistory';
import PopUp from '../../../commonModules/interface/PopUp';
import SwipeableTabs from '../../../commonModules/MUI/SwipeableTabs';
import { sortByDateReverse } from '../../../../../../jsx/actions/utils';
import CommercialStats from './PopUp/CommercialStats';


class CommercialPopUp extends React.PureComponent {
    state = {
        stocks: null,

        headerMenu: this.props.default_tab || "DASHBOARD",
        file:"",
    }
    
    sortByDate = (list) => {
        // console.log(list);
        list.sort((a, b) => {
            a = new Date(a);
            b = new Date(b);
            if (a > b){
                return 1;
            }
            if (a < b){
                return -1;
            }
            return 0;
        });
        return list
    } 
    componentDidMount = async () => {
        if(!this.props.commercial.other){
            await this.props.updateAgent(this.props.commercial)
        }
        if(isEmpty(this.props.PRODUCTS)){
            await this.props.fetchProducts()
        }
        // if(isEmpty(this.props.SALES)){
        //     await this.props.fetchSales()
        // }
        // if( isEmpty(this.props.COMMERCIAL_STOCKS) ){
        //     await this.props.fetchCommercialStocks()
        // }
        this.fetchCommercialStocks()
        // if( isEmpty(this.props.COMMERCIAL_REAS) ){
        //     await this.props.fetchCommercialReas()
        // }
        // if( isEmpty(this.props.COMMERCIAL_RETURNS) ){
        //     await this.props.fetchCommercialReturns()
        // }
        this.fetchCommercialHistory()
        // get commercial Stats Stocks & other infos 
    }
    refreshData = async () => {
        this.setState({ loading: true})

        // await this.props.fetchCommercialStocks()
        this.fetchCommercialStocks()
        // await this.props.fetchCommercialReas()
        // await this.props.fetchCommercialReturns()
        this.fetchCommercialHistory()

        this.setState({ loading: false})
        
    }
    // fetchCommercialStocks = async () => {
    //     const { COMMERCIAL_STOCKS } = this.props;
    //     let stocks = []
    //     if( !isEmpty(COMMERCIAL_STOCKS) ){

    //         COMMERCIAL_STOCKS[this.props.commercial.id] && COMMERCIAL_STOCKS[this.props.commercial.id].forEach( stock => {
    //             stock.product = this.props.PRODUCTS[stock.product_id]
    //             stocks.push(stock)
    //         })
    //     }
        
    //     this.setState({
    //         stocks
    //     })
    // }

    // fetchCommercialHistory = async () => {
    //     let history = []
    //     const { COMMERCIAL_REAS, COMMERCIAL_RETURNS, PRODUCTS, SALES, commercial } = this.props;
    //     if( !isEmpty(COMMERCIAL_REAS) ) {
    //         let list = Object.values(COMMERCIAL_REAS).concat(Object.values(COMMERCIAL_RETURNS))
    //         console.log("list 1", list.length);
    //         list = list.concat(Object.values(SALES))
    //         console.log("list 2", list.length);
            
           
    //         list = list.filter( op => op.commercial_id === commercial.id)
    //         sortByDateReverse(list, "date")
            
    //         list.forEach( op => {
    //             op.products.forEach( prod => {
    //                 history.push({
    //                     history_date: op.date,
    //                     history_product: prod.product_id,
    //                     history_quantity: prod.quantity,
    //                     history_stock_cost: prod.stock_cost,
    //                     operation: op.nature,
    //                     product: PRODUCTS[prod.product_id]
    //                     // history_price: 0,
    //                     // history_priceHT: 0,
    //                     // history_price_out: 0,
    //                     // history_pu: 0,
    //                     // history_shop_id: "",
    //                 })
    //             })
    //         })
            
    //         // console.log("get commercial history", {list, history});
    //     }

    //     this.setState({
    //         history
    //     })
    // }
        
    fetchCommercialStocks = async () => {
        let stocks = []
        try {
            const response = await fetch('/stocks/commercial/agent/stockList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({commercialID: this.props.commercial.id}),
                credentials: 'same-origin',
            }); 
            const list = await response.json()
            console.log(list)// list returns new object created
            if(list.error){ // no errors, return new Object
                console.log("error list fetched", list.error)      
            } else {
                list.forEach( stock => {
                    stock.product = this.props.PRODUCTS[stock.product_id]
                    stocks.push(stock)
                })
            }
        } catch (err) {
            console.log("catch error", err)
        }
        this.setState({
            stocks
        })
    }
    fetchCommercialHistory = async () => {
        let history = []
        try {
            const response = await fetch('/stocks/commercial/agent/stock/history',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({commercialID: this.props.commercial.id}),
                credentials: 'same-origin',
            }); 
            
            const list = await response.json()
            console.log(list)// list returns new object created
            if(list.error){ // no errors, return new Object
                console.log("error list fetched", list.error)
            } else {
                list.reverse().forEach( stock => {
                    stock.product = this.props.PRODUCTS[stock.history_product]
                    history.push(stock)
                })
            }
            
        } catch (err) {
            console.log("catch error", err)
        }

        this.setState({
            history
        })
    }
    render() {
        // console.log('COMMERCIAL POP UP INFO in PopupInfo : ', this.props);
        // console.log('================STATE====================');
        // console.log(this.state);
        // console.log('====================================');
        return (
            <PopUp
                title={this.props.commercial.name}
                close={this.props.closePopUp}
            >
                <SwipeableTabs
                    labels={["Dashboard", "Stats", "Etat Stock", "Historique"]}
                    default="Dashboard"
                >
                    <CommercialDashboard 
                        commercial={this.props.commercial} 
                        // history={this.state.history} 
                        // PRODUCTS={this.props.PRODUCTS} 
                        // loading={this.state.loading} 
                    />
                    <CommercialStats 
                        commercial={this.props.commercial} 
                        history={this.state.history} 
                        PRODUCTS={this.props.PRODUCTS} 
                        loading={this.state.loading} 
                    />
                    <CommercialStockInfo 
                        commercialID={this.props.commercial.id} 
                        stocks={this.state.stocks} 
                        PRODUCTS={this.props.PRODUCTS} 
                        refreshData={this.refreshData} 
                        loading={this.state.loading} 
                    />
                    <CommercialHistory 
                        commercialID={this.props.commercial.id} 
                        history={this.state.history} 
                        PRODUCTS={this.props.PRODUCTS} 
                        refreshData={this.refreshData} 
                        loading={this.state.loading} 
                    />
                </SwipeableTabs>
            </PopUp>
        );
    }
}


export default CommercialPopUp;
